import React, { useEffect, useState, useContext } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import axios from "axios";
// @mui/material components
import { makeStyles } from "@mui/styles";
// @mui/icons-material
import PermIdentity from "@mui/icons-material/PermIdentity";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import UserService from "../../services/UserService";
import { updateUserProfileData, getUserProfileData } from "../../services/ConfigServices";
import { NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';

import TextInput from "components/Input/TextInput.js";
import { CustomSelect, } from "components/Input/Index.js";
import postPageVisit from "services/LogService";
import { optionsData } from "variables/lists/user";

const useStyles = makeStyles(styles);


function Profile() {

    const options = JSON.parse(localStorage.getItem('memoptions')) || [];
    const currentusertype = localStorage.getItem("userType");
    //console.log(currentusertype);
    const appContext = useContext(AdvancedSearchContext);
    const { setPage } = appContext;
    const [redirState, setRedirState] = useState(false);
    const classes = useStyles();
    const [profileFirstName, setProfileFirstName] = useState(UserService.getFirstName());
    const [profileLastName, setProfileLastName] = useState(UserService.getLastName());
    const [profileEmail, setProfileEmail] = useState(UserService.getEmail());
    const [profilePhone, setProfilePhone] = useState([]);
    const [notifications, setNotifications] = useState({});


    useEffect(() => {
        getUserParam();
        setPage('profil');
        postPageVisit('profil');
    }, [setPage])

    const getUserParam = () => {
        axios.get(getUserProfileData(),
            {
                headers: {
                    Authorization: `Bearer ${UserService.getToken()}`
                }
            }).then(response => {
                if (response.status === 200) {
                    const userData = response.data;
                    setProfileFirstName(userData.firstname);
                    setProfileLastName(userData.lastname);
                    setProfileEmail(userData.email);
                    setProfilePhone(userData.phone[0]);
                    setNotifications(userData.notifications);
                } else if (response.status === 401) {
                    console.error('Unauthorized');
                }
            }).catch((error) => {
                if (error.response) {
                    console.error("ERROR!!", error.message);
                    // window.location.reload();
                } else if (error.request) {
                    console.error("request error", error.request);
                    //UserService.getLogout();
                }
            })
    }

    const handleNotificationsChange = (key, value) => {
        let newnotifications = { ...notifications };
        if (!newnotifications[key])
            newnotifications[key] = {};
        if (value === "no") {
            newnotifications[key].notification = false;
            newnotifications[key].email = false;
        }
        else if (value === "email") {
            newnotifications[key].notification = true;
            newnotifications[key].email = true;
        }
        setNotifications(newnotifications);
    }

    const getNotificationValue = (key) => {
        if (notifications[key] && notifications[key].notification === false && notifications[key].email === false)
            return "no";
        else if (notifications[key] && notifications[key].notification === true && notifications[key].email === true)
            return "email";
        else
            return "no";
    }

    const updateProfile = async () => {
        const updatedUserData = {
            firstname: profileFirstName,
            lastname: profileLastName,
            email: profileEmail,
            notifications: notifications,
            phone: [profilePhone],
        }
        try {
            const resp = await axios.put(updateUserProfileData(), updatedUserData, {
                headers: {
                    Authorization: `Bearer ${UserService.getToken()}`,
                    'Content-Type': "application/json; charset=utf-8",
                }
            });
            if (resp.status === 200) {
                NotificationManager.success('Profil modifié');
            } else {
                NotificationManager.error("Une erreur est survenue");
            }
        } catch (error) {
            if (error.response) {
                NotificationManager.error("Une erreur est survenue");
            } else if (error.request) {
                NotificationManager.error("Une erreur est survenue");
            }
        }
    }

    const Logout = () => {
        UserService.getLogout();
        localStorage.clear();
    }

    let redirecting = redirState && (
        <Navigate
            push
            to={{
                pathname: "/admin/user-profile",
            }}
        />
    );
    return (
        <ErrorBoundary
            onReset={() => setRedirState(true)}
            FallbackComponent={ErrorFallbackDialog}
            page={"user-profile"}
        >
            <div>
                <GridContainer style={{ marginTop: '2rem' }}>
                    <GridItem xs={12} sm={12}>
                        <Card>
                            <CardHeader color="success" icon>
                                <CardIcon color="success">
                                    <PermIdentity />
                                </CardIcon>
                                <legend className={classes.cardIconTitle}>
                                    Mon profil
                                </legend>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <div>
                                            <TextInput
                                                inputTitle={"Nom"}
                                                textInput={profileLastName}
                                                handleTextInputChange={(e) => {
                                                    setProfileLastName(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <div>
                                            <TextInput
                                                inputTitle={"Prénom"}
                                                textInput={profileFirstName}
                                                handleTextInputChange={(e) => {
                                                    setProfileFirstName(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <div>
                                            <TextInput
                                                inputTitle={"Téléphone"}
                                                textInput={profilePhone}
                                                handleTextInputChange={(e) => {
                                                    setProfilePhone(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <div>
                                            <TextInput
                                                inputTitle={"Email"}
                                                textInput={profileEmail}
                                                disabled={true}
                                            />
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    {

                        <GridItem xs={12} sm={12}>
                            <Card>
                                <CardHeader color="success" icon>
                                    <CardIcon color="success">
                                        <NotificationsNoneIcon />
                                    </CardIcon>
                                    <legend className={classes.cardIconTitle}>Notifications</legend>
                                </CardHeader>
                                <CardBody>
                                    <div>
                                        <CustomSelect
                                            inputTitle={"Autorisations expirées"}
                                            selectValue={getNotificationValue("authorizationexpired")}
                                            handleSelectValueChange={event => handleNotificationsChange("authorizationexpired", event.target.value)}
                                            data={optionsData}
                                        />
                                    </div>
                                    {currentusertype === '1' &&
                                        <div>
                                            <CustomSelect
                                                inputTitle={"Autorisations créée par un utilisateur"}
                                                selectValue={getNotificationValue("authorizationcreated")}
                                                handleSelectValueChange={event => handleNotificationsChange("authorizationcreated", event.target.value)}
                                                data={optionsData}
                                            />
                                        </div>}
                                    {currentusertype === '1' &&
                                        <div>
                                            <CustomSelect
                                                inputTitle={"Déplacement d'un groupe par un utilisateur"}
                                                selectValue={getNotificationValue("groupmovedbyuser")}
                                                handleSelectValueChange={event => handleNotificationsChange("groupmovedbyuser", event.target.value)}
                                                data={optionsData}
                                            />
                                        </div>}
                                    {currentusertype === '1' &&
                                        <div>
                                            <CustomSelect
                                                inputTitle={"Import d'un fichier par un utilisateur"}
                                                selectValue={getNotificationValue("fileimportbyuser")}
                                                handleSelectValueChange={event => handleNotificationsChange("fileimportbyuser", event.target.value)}
                                                data={optionsData}
                                            />
                                        </div>}
                                    {(currentusertype === '1' || (options.find((x) => x.id === 'markets'))) &&
                                        <div>
                                            <CustomSelect
                                                inputTitle={"Notifications des groupements d'achat"}
                                                selectValue={getNotificationValue("marketordersvalidate")}
                                                handleSelectValueChange={event => handleNotificationsChange("marketordersvalidate", event.target.value)}
                                                data={optionsData}
                                            />
                                        </div>
                                    }
                                    {(currentusertype === '1' || (options.find((x) => x.id === 'cee'))) &&
                                        <div>
                                            <CustomSelect
                                                inputTitle={"Notifications des campagnes CEE"}
                                                selectValue={getNotificationValue("ceecampaign")}
                                                handleSelectValueChange={event => handleNotificationsChange("ceecampaign", event.target.value)}
                                                data={optionsData}
                                            />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </GridItem>
                    }

                    {/* <GridItem xs={12} sm={12}>
                    <Card>
                        <CardHeader color="success" icon>
                            <CardIcon color="success">
                                <NotificationsNoneIcon/>
                            </CardIcon>
                            <legend className={classes.cardIconTitle}>Notifications</legend>
                        </CardHeader>
                        <CardBody>
                            <div className={classes.block}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={emailAlert}
                                            onChange={event => setEmailAlert(event.target.checked)}
                                            value="activeAlert"
                                            color="secondary"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    }
                                    classes={{
                                        label: labelClasse.labelStyle
                                    }}
                                    label="Recevoir les alertes par email"
                                    labelPlacement={'start'}
                                />
                            </div>
                            <div className={classes.block}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={emailImport}
                                            onChange={event => setEmailImport(event.target.checked)}
                                            value="activeAlert"
                                            color="secondary"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    }
                                    classes={{
                                        label: labelClasse.labelStyle
                                    }}
                                    label="Recevoir des notifications sur les imports de données"
                                    labelPlacement={'start'}
                                />
                            </div>
                            <div className={classes.block}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={emailRapport}
                                            onChange={event => setEmailRapport(event.target.checked)}
                                            value="activeAlert"
                                            color="secondary"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    }
                                    classes={{
                                        label: labelClasse.labelStyle
                                    }}
                                    label="Recevoir des notifications lorsqu' un rapport est prêt"
                                    labelPlacement={'start'}
                                />
                            </div>
                            <div className={classes.block}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={emailRapportPj}
                                            onChange={event => setEmailRapportPj(event.target.checked)}
                                            value="activeAlert"
                                            color="secondary"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    }
                                    classes={{
                                        label: labelClasse.labelStyle
                                    }}
                                    label="Recevoir les rapports en pièce jointe par email"
                                    labelPlacement={'start'}
                                />
                            </div>
                            <div className={classes.block}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={emailAction}
                                            onChange={event => setEmailAction(event.target.checked)}
                                            value="activeAlert"
                                            color="secondary"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    }
                                    label="Recevoir des notifications sur mes plans d' actions"
                                    labelPlacement={'start'}
                                    classes={{
                                        label: labelClasse.labelStyle
                                    }}
                                />
                            </div>
                            <div className={classes.block}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={emailGed}
                                            onChange={event => setEmailGed(event.target.checked)}
                                            value="activeAlert"
                                            color="secondary"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    }
                                    classes={{
                                        label: labelClasse.labelStyle
                                    }}
                                    label="Recevoir des notifications sur ma GED"
                                    labelPlacement={'start'}
                                />
                            </div>
                            <div className={classes.block}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={emailPatrimoine}
                                            onChange={event => setEmailPatrimoine(event.target.checked)}
                                            value="activeAlert"
                                            color="secondary"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    }
                                    classes={{
                                        label: labelClasse.labelStyle
                                    }}
                                    label="Recevoir des notifications sur mon patrimoine"
                                    labelPlacement={'start'}
                                />
                            </div>
                        </CardBody>
                        <NotificationContainer/>
                    </Card>
                </GridItem> */}
                </GridContainer>

                <GridContainer 
                style={{
                    // display: 'inline-flex',
                    // flexDirection: 'row',
                    // flexWrap: 'nowrap',
                    // alignContent: 'center',
                    justifyContent: 'center',
                    // alignItems: 'center',
                }}
                >
                    <GridItem xs={6} sm={6} md={4}>
                        <Button
                            color="success" className={classes.updateProfileButton}
                            onClick={updateProfile}>
                            Modifier
                        </Button>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={4}>
                        <Button
                            color="danger" className={classes.disconnectProfile}
                            onClick={Logout}>
                            Se déconnecter
                        </Button>
                    </GridItem>
                </GridContainer>

            </div>
            {redirecting}
        </ErrorBoundary>
    );
}

export default Profile;
